import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { UserInfoModel } from 'src/app/services/models/user-info.model';
import { NavService } from 'src/app/services/nav.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-consent',
  templateUrl: './consent.page.html',
  styleUrls: ['./consent.page.scss'],
})

export class ConsentPage implements OnInit {
  user: UserInfoModel;

  constructor(
    private userService: UserService,
    private authService: AuthService,
    private linkSystem: NavService
  ) {}

  ngOnInit() {
    this.loadUser();
  }

  async loadUser() {
    try {
      const user = await this.userService.getUserInfo();
      this.user = user;
    } catch (error) {
      console.error('Failed to load user info:', error);
    }
  }

  async onAccept() {
    try {
      await this.userService.acceptConsent();
      await this.loadUser();
      this.linkSystem.navigateHome();
    } catch (error) {
      console.error('Consent accept failed:', error);
    }
  }

  onDecline() {
    this.authService.logout();
  }
}
